/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rate: NonNullable<unknown> }} Endpoint_Hero_Rate_NoteInputs */

const en_endpoint_hero_rate_note = /** @type {((inputs: Endpoint_Hero_Rate_NoteInputs) => LocalizedString) & { parts: (inputs: Endpoint_Hero_Rate_NoteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Hero_Rate_NoteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.rate}, pay per request, no subscription.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Hero_Rate_NoteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "rate", options: {}, attributes: {} }, { type: "text", value: String(i?.rate) }, { type: "markup-end", name: "rate", options: {}, attributes: {} }, { type: "text", value: ", pay per request, no subscription." }])
			})
		}
	)
);

const zh_hans1_endpoint_hero_rate_note = /** @type {((inputs: Endpoint_Hero_Rate_NoteInputs) => LocalizedString) & { parts: (inputs: Endpoint_Hero_Rate_NoteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Hero_Rate_NoteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.rate}，按请求付费，无需订阅。`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Hero_Rate_NoteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "rate", options: {}, attributes: {} }, { type: "text", value: String(i?.rate) }, { type: "markup-end", name: "rate", options: {}, attributes: {} }, { type: "text", value: "，按请求付费，无需订阅。" }])
			})
		}
	)
);

const pt_br2_endpoint_hero_rate_note = /** @type {((inputs: Endpoint_Hero_Rate_NoteInputs) => LocalizedString) & { parts: (inputs: Endpoint_Hero_Rate_NoteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Hero_Rate_NoteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.rate}, pague por requisição, sem assinatura.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Hero_Rate_NoteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "rate", options: {}, attributes: {} }, { type: "text", value: String(i?.rate) }, { type: "markup-end", name: "rate", options: {}, attributes: {} }, { type: "text", value: ", pague por requisição, sem assinatura." }])
			})
		}
	)
);

const es_endpoint_hero_rate_note = /** @type {((inputs: Endpoint_Hero_Rate_NoteInputs) => LocalizedString) & { parts: (inputs: Endpoint_Hero_Rate_NoteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Hero_Rate_NoteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.rate}, pagas por solicitud, sin suscripción.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Hero_Rate_NoteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "rate", options: {}, attributes: {} }, { type: "text", value: String(i?.rate) }, { type: "markup-end", name: "rate", options: {}, attributes: {} }, { type: "text", value: ", pagas por solicitud, sin suscripción." }])
			})
		}
	)
);

const fr_endpoint_hero_rate_note = /** @type {((inputs: Endpoint_Hero_Rate_NoteInputs) => LocalizedString) & { parts: (inputs: Endpoint_Hero_Rate_NoteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Hero_Rate_NoteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.rate}, paiement à la requête, sans abonnement.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Hero_Rate_NoteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "rate", options: {}, attributes: {} }, { type: "text", value: String(i?.rate) }, { type: "markup-end", name: "rate", options: {}, attributes: {} }, { type: "text", value: ", paiement à la requête, sans abonnement." }])
			})
		}
	)
);

const de_endpoint_hero_rate_note = /** @type {((inputs: Endpoint_Hero_Rate_NoteInputs) => LocalizedString) & { parts: (inputs: Endpoint_Hero_Rate_NoteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Hero_Rate_NoteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.rate}, Zahlung pro Anfrage, kein Abo.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Hero_Rate_NoteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "rate", options: {}, attributes: {} }, { type: "text", value: String(i?.rate) }, { type: "markup-end", name: "rate", options: {}, attributes: {} }, { type: "text", value: ", Zahlung pro Anfrage, kein Abo." }])
			})
		}
	)
);

const ru_endpoint_hero_rate_note = /** @type {((inputs: Endpoint_Hero_Rate_NoteInputs) => LocalizedString) & { parts: (inputs: Endpoint_Hero_Rate_NoteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Hero_Rate_NoteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.rate}, оплата за запрос, без подписки.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Hero_Rate_NoteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "rate", options: {}, attributes: {} }, { type: "text", value: String(i?.rate) }, { type: "markup-end", name: "rate", options: {}, attributes: {} }, { type: "text", value: ", оплата за запрос, без подписки." }])
			})
		}
	)
);

const it_endpoint_hero_rate_note = /** @type {((inputs: Endpoint_Hero_Rate_NoteInputs) => LocalizedString) & { parts: (inputs: Endpoint_Hero_Rate_NoteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Hero_Rate_NoteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.rate}, paghi a richiesta, nessun abbonamento.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Hero_Rate_NoteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "rate", options: {}, attributes: {} }, { type: "text", value: String(i?.rate) }, { type: "markup-end", name: "rate", options: {}, attributes: {} }, { type: "text", value: ", paghi a richiesta, nessun abbonamento." }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "{rate}, pay per request, no subscription." |
*
* @param {Endpoint_Hero_Rate_NoteInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_hero_rate_note = /** @type {((inputs: Endpoint_Hero_Rate_NoteInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & { parts: (inputs: Endpoint_Hero_Rate_NoteInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Endpoint_Hero_Rate_NoteInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, { rate: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Hero_Rate_NoteInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString} */ ((inputs, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "zh-Hans") return zh_hans1_endpoint_hero_rate_note(inputs)
			if (locale === "pt-BR") return pt_br2_endpoint_hero_rate_note(inputs)
			if (locale === "es") return es_endpoint_hero_rate_note(inputs)
			if (locale === "fr") return fr_endpoint_hero_rate_note(inputs)
			if (locale === "de") return de_endpoint_hero_rate_note(inputs)
			if (locale === "ru") return ru_endpoint_hero_rate_note(inputs)
			if (locale === "it") return it_endpoint_hero_rate_note(inputs)
			return en_endpoint_hero_rate_note(inputs)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Hero_Rate_NoteInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[]} */ ((inputs, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "zh-Hans") return typeof zh_hans1_endpoint_hero_rate_note.parts === "function" ? zh_hans1_endpoint_hero_rate_note.parts(inputs) : [{ type: "text", value: zh_hans1_endpoint_hero_rate_note(inputs) }]
				if (locale === "pt-BR") return typeof pt_br2_endpoint_hero_rate_note.parts === "function" ? pt_br2_endpoint_hero_rate_note.parts(inputs) : [{ type: "text", value: pt_br2_endpoint_hero_rate_note(inputs) }]
				if (locale === "es") return typeof es_endpoint_hero_rate_note.parts === "function" ? es_endpoint_hero_rate_note.parts(inputs) : [{ type: "text", value: es_endpoint_hero_rate_note(inputs) }]
				if (locale === "fr") return typeof fr_endpoint_hero_rate_note.parts === "function" ? fr_endpoint_hero_rate_note.parts(inputs) : [{ type: "text", value: fr_endpoint_hero_rate_note(inputs) }]
				if (locale === "de") return typeof de_endpoint_hero_rate_note.parts === "function" ? de_endpoint_hero_rate_note.parts(inputs) : [{ type: "text", value: de_endpoint_hero_rate_note(inputs) }]
				if (locale === "ru") return typeof ru_endpoint_hero_rate_note.parts === "function" ? ru_endpoint_hero_rate_note.parts(inputs) : [{ type: "text", value: ru_endpoint_hero_rate_note(inputs) }]
				if (locale === "it") return typeof it_endpoint_hero_rate_note.parts === "function" ? it_endpoint_hero_rate_note.parts(inputs) : [{ type: "text", value: it_endpoint_hero_rate_note(inputs) }]
				return typeof en_endpoint_hero_rate_note.parts === "function" ? en_endpoint_hero_rate_note.parts(inputs) : [{ type: "text", value: en_endpoint_hero_rate_note(inputs) }]
			})
		}
	)
);